import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IDocumentValidation } from './../interfaces/document-validation-interface';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-pqrform',
  templateUrl: './pqrform.component.html',
  styleUrls: ['./pqrform.component.scss'],
})
export class PQRformComponent implements OnInit {
  public pqrForm: FormGroup;

  @Input() documentInformation: IDocumentValidation;
  @Output()
  pqrSent = new EventEmitter<null>(null);

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.restartForm();
  }

  public handleFormSubmit(): void {
    const formValues = this.pqrForm.getRawValue();

    const payload = {
      ...formValues,
      kind: parseInt(formValues.kind, 10),
      reason: parseInt(formValues.reason, 10),
      client_id: this.documentInformation.id,
    };

    this.http.post(environment.apiUrl + '/pqrs', payload).subscribe(
      (data: { code: string }) => {
        Swal.fire({
          icon: 'success',
          title: 'Radicación Exitosa',
          text: `Tu solicitud ha sido radicada con el numero ${data.code}.
           Un correo de confirmación te será enviado. revisa SPAM`,
          confirmButtonText: 'Entendido',
        });
      },
      () => {
        Swal.fire({
          icon: 'error',
          title: 'Ha ocurrido un error radicando tu PQR',
          text: 'Comunicate a la linea fija nacional 7467581',
          confirmButtonText: 'Entendido',
        });
      }
    );
    this.restartForm();
    this.pqrSent.emit();
  }

  private restartForm(): void {
    this.pqrForm = new FormGroup({
      kind: new FormControl('1', Validators.required),
      reason: new FormControl('1', Validators.required),
      email: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.email])
      ),
      description: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(2000)])
      ),
    });
  }
}
